import { alpha } from '@mui/material/styles';

const NUDGE_BORDER_ALPHA = 0.4;
const NUDGE_BG_ALPHA = 0.1;

export const nudgeStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '16px',
  padding: '12px 14px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${alpha(palette.warning.main, NUDGE_BORDER_ALPHA)}`,
  backgroundColor: ({ palette }) => alpha(palette.warning.main, NUDGE_BG_ALPHA),
};

export const iconStyles = {
  display: 'flex',
  flexShrink: 0,
  color: ({ palette }) => palette.warning.main,
};

export const textStyles = {
  flex: 1,
  minWidth: 0,
  color: ({ palette }) => palette.text.primary,
};

export const highlightStyles = {
  color: ({ palette }) => palette.warning.main,
};

export const actionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flexShrink: 0,
};

export const primaryActionStyles = {
  padding: '2px 6px',
  minWidth: 'auto',
  color: ({ palette }) => palette.warning.main,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
};

export const skipActionStyles = {
  padding: '2px 6px',
  minWidth: 'auto',
  color: ({ palette }) => palette.text.secondary,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
};
